import React from 'react';
import { motion } from 'framer-motion';
import { GraduationCap, UserCheck, Check } from 'lucide-react';
const studentOutcomes = ['Analizarán riesgos reales', 'Sabrán cómo actuar ante emergencias', 'Usarán checklists profesionales', 'Tomarán decisiones con criterio técnico', 'Se prepararán para prácticas y pasantías', 'Saldrán realmente listos para el mundo laboral'];
const teacherOutcomes = ['Ahorrarás horas cada semana (todo ya está armado)', 'Enseñarás con seguridad y sin improvisar', 'Tendrás toda la cursada resuelta en un solo material', 'Elevarás el nivel profesional de tus clases', 'Disfrutarás más enseñando sin estrés', 'Tendrás material validado técnicamente'];
export function BenefitsSection() {
  return <section className="py-20 bg-gray-50" data-id="element-3">
      <div className="container mx-auto px-4" data-id="element-4">
        <div className="grid lg:grid-cols-2 gap-12" data-id="element-5">
          {/* Student Benefits */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white p-8 rounded-3xl shadow-lg border-t-8 border-blue-600" data-id="element-6">
            <div className="flex items-center gap-4 mb-8" data-id="element-7">
              <div className="bg-blue-100 p-4 rounded-full" data-id="element-8">
                <GraduationCap className="w-8 h-8 text-blue-600" data-id="element-9" />
              </div>
              <h3 className="text-2xl md:text-3xl font-bold text-gray-800" data-id="element-10">
                ¿Qué lograrán tus alumnos?
              </h3>
            </div>

            <ul className="space-y-4" data-id="element-11">
              {studentOutcomes.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-12">
                  <Check className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5" data-id="element-13" />
                  <span className="text-lg text-gray-700" data-id="element-14">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Teacher Benefits */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white p-8 rounded-3xl shadow-lg border-t-8 border-yellow-400" data-id="element-15">
            <div className="flex items-center gap-4 mb-8" data-id="element-16">
              <div className="bg-yellow-100 p-4 rounded-full" data-id="element-17">
                <UserCheck className="w-8 h-8 text-yellow-600" data-id="element-18" />
              </div>
              <h3 className="text-2xl md:text-3xl font-bold text-gray-800" data-id="element-19">
                ¿Qué lograrás vos?
              </h3>
            </div>

            <ul className="space-y-4" data-id="element-20">
              {teacherOutcomes.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-21">
                  <Check className="w-6 h-6 text-yellow-500 flex-shrink-0 mt-0.5" data-id="element-22" />
                  <span className="text-lg text-gray-700" data-id="element-23">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}